
<template>
    <vs-row>
       <vs-row vs-type="flex" vs-justify="start">
            <div vs-lg="3"><h4 class="pl-4">Submitted By: </h4></div>
            <div vs-lg="9" class="px-3"><a @click="showingContactModal(data.profile)" v-for="(data,index) in cardDetails.profiles" :key="index" class="cursor-pointer">
                <span style="color:white;" v-show="index === 0 || (index > 0 && cardDetails.profiles[index - 1].profile.user._id !== data.profile.user._id)">{{index + 1}} - </span>{{index === 0 || (index > 0 && cardDetails.profiles[index - 1].profile.user._id !== data.profile.user._id) ? data.profile.user.firstname+' '+data.profile.user.lastname : '' }} </a>
            </div>
       </vs-row>
        <div class="mt-5 w-full">
            <form-wizard class="ml-1 mt-2" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Add Card" ref="wiz" @click.native="displayContactModal = false">
                  <template slot="next">
                    <vs-button class="ml-5 px-6 wizardBtnPad">Next</vs-button>
                </template>
                <template slot="prev">
                    <vs-button class="ml-5 px-6 wizardBtnPad">Back</vs-button>
                </template>
                <template slot="finish">
                    <vs-button class="ml-5 px-6 wizardBtnPad" @click="approveCard">Approve Card</vs-button>
                </template>
                <tab-content title="" class="mb-5" :before-change="beforeFirstTabChange">
                    <vs-row class="tabCard">
                        <vs-row>
                            <h3 class="p-5">Card Details</h3>
                        </vs-row>
                        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
                            
                            <div class="dropdown mt-1 w-full" id="dropdown">
                                <div class="addCardFont font-semibold ml-5">Issuer<span v-if="errors.issuerName.success" class="sterik"> *</span>
                                                                    <span v-if="!errors.issuerName.success"> *</span></div>
                               <vs-input :danger="errors.issuerName.success"
                                    :danger-text="errors.issuerName.msg"
                                    class="w-full p-5 pt-4"
                                    @click="handleFilter"
                                    v-on-clickaway="closeColorList"
                                    v-model="temp_issuer_name"
                                    @input="checkIssuerName(temp_issuer_name)"
                                />
                                <div class="dropdown-content" v-show="toggleColorList">
                                            <div class="colorItemContainer" @click="setIssuer(issuer)" :key="index" v-for="(issuer, index) in issuersList">
                                                <div class="colorIconStyle" :style="{'background-color': issuer.color}"></div>
                                                <span class="colorTextStyle">{{ issuer.name }}</span>
                                            </div>
                                        </div>
                                </div>
                                <div class="addCardFont font-semibold ml-5">Card Name<span v-if="errors.cardName.success" class="sterik"> *</span>
                                                            <span v-if="!errors.cardName.success"> *</span></div>
                        <vs-input class="w-full p-5" 
                            v-model="cardDetails.name" 
                            :danger="errors.cardName.success"
                            :danger-text="errors.cardName.msg"
                            @input="validateCardName($event)"
                            maxLength="120"  />
                            <vs-row>
                                <div class="addCardFont font-semibold ml-5 mt-1">Card Type</div>
                            </vs-row>
                            <vs-row class="mt-2">
                                <vs-radio v-model="cardDetails.card_type" vs-name="creditType" vs-value="credit" class="m-5 addCardFont textSize" @change="cardDetails.card_type = 'credit'">Credit</vs-radio>
                                <vs-radio v-model="cardDetails.card_type" vs-name="creditType" vs-value="charge" class="m-5 addCardFont textSize" @change="cardDetails.card_type = 'charge'">Charge</vs-radio>
                            </vs-row>
                        
                            <vs-row class="p-5 m-5" vs-type="flex" vs-justify="center">
                                <vs-col vs-lg="6">
                                    <div @click="$refs.uploadAddCard.click()" class="uploadLabelWizard">{{ cardDetails.photo ? cardDetails.photo.name : 'Upload Card Picture' }}</div>
                                    <input type="file" class="hidden" ref="uploadAddCard" @change="showFilePath">
                                </vs-col>

                                <vs-col vs-lg="2" class="uploadContainerAddWizard">
                                     <div class="btn-addon">
                                      <vs-button size="small" color="primary" @click="$refs.uploadAddCard.click()">
                                          <UploadCloudIcon />
                                      </vs-button>
                                    </div>
                                </vs-col>
                                 <vs-row class="pl-6 ml-6">
                                    <div v-show="errors.photo.success" class="ml-6 pl-6">
                                        <div id="errFont" class="dangerColor mt-3">
                                            <span class="ml-6 pl-6">{{ errors.photo.msg }}</span>
                                        </div>
                                    </div>
                                </vs-row>
                            </vs-row>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
                            <div class="addCardFont font-semibold ml-5">Product Change</div>
                            <vs-row>
                                 <vs-col class="px-4 mt-5 pr-5">
                                     <select 
                                        v-if="cardsList.length > 0"
                                        v-model="cardDetails.product_change" 
                                        :class="{'w-full posSelect p-3': true, 'mb-2': cardDetails.product_change }"
                                        @change="handleCardFilter">
                                        <option v-for="card in cardsList" :key="card._id" :value="card._id">
                                            {{ card.name }}
                                        </option>
                                  </select>
                                   <select 
                                        v-else
                                        class="w-full posSelect p-3 mb-2"
                                        :disabled="true">
                                    <option selected>No Cards Available</option>
                                  </select>
                                </vs-col>
                             </vs-row>
                                         <div class="addCardFont font-semibold ml-5 mt-4">Upgrade Card</div>
                            <vs-col class="px-4 mt-5 mb-4 pr-5">
                                     <select 
                                        v-if="cardsList.length > 0"
                                        v-model="cardDetails.upgrade_card" 
                                        class="w-full posSelect p-3"
                                        @change="handleCardFilter">
                                        <option v-for="card in cardsList" :key="card._id" :value="card._id">
                                            {{ card.name }}
                                        </option>
                                    </select>
                                     <select 
                                            v-else
                                            class="w-full posSelect p-3"
                                            :disabled="true">
                                        <option selected>No Cards Available</option>
                                    </select>
                                 </vs-col>
                            <div class="addCardFont font-semibold ml-5">Downgrade Card</div>
                               <vs-row>
                                 <vs-col class="px-4 mt-5 pr-5">
                                    <select 
                                        v-if="cardsList.length > 0"
                                        v-model="cardDetails.downgrade_card" 
                                        class="w-full posSelect p-3"
                                        @change="handleCardFilter">
                                        <option v-for="card in cardsList" :key="card._id" :value="card._id">
                                            {{ card.name }}
                                        </option>
                                  </select>
                                  <select 
                                        v-else
                                        class="w-full posSelect p-3"
                                        :disabled="true">
                                    <option selected>No Cards Available</option>
                                </select>
                                </vs-col>
                             </vs-row>
                        </vs-col>
                    </vs-row>
                </tab-content>
                  <tab-content title="" class="mb-5" :before-change="beforeSecondTabChange">

                    <vs-row class="tabCard">
                        <vs-row>
                            <h3 class="p-5">Annual Fees</h3>
                        </vs-row>
                        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
                            <div class="addCardFont font-semibold ml-5">Annual Fee<span v-if="errors.annualFee.success" class="sterik"> *</span>
                            <span v-if="!errors.annualFee.success"> *</span>
                            </div>
                            <vs-input type="number" 
                            min="0" 
                            maxlength="20"
                            class="w-full p-5"
                             v-model="cardDetails.annual_fee" 
                             :danger="errors.annualFee.success"
                            :danger-text="errors.annualFee.msg"
                             @input="calculateEffectiveFee"
                             @keydown="validateNumeric($event)"/>                            
                            <!-- <vs-row> -->
                               
                            <!-- </vs-row> -->
                        </vs-col>
                         <vs-col vs-lg="3" vs-sm="12" class="inputContainer">
                            <div class="addCardFont font-semibold ml-5">International Transaction Fee</div>
                            <vs-row class="mt-2">
                                <vs-radio v-model="cardDetails.international_transaction" vs-name="type" :vs-value="true" class="m-5" @change="cardDetails.international_transaction = true">Yes</vs-radio>
                                <vs-radio v-model="cardDetails.international_transaction" vs-name="type" :vs-value="false" class="m-5" @change="cardDetails.international_transaction = false">No</vs-radio>
                            </vs-row>
                        </vs-col>
                          <vs-col vs-lg="3" vs-sm="12" class="inputContainer pt-2 max-height-5-24" vs-type="flex" vs-justify="center">
                                <vs-checkbox v-model="cardDetails.five_twenty_four" vs-name="rule-type" :vs-value="true" class="m-2 mt-5"/>
                                <div class="addCardFont font-semibold ml-0 mt-5 pt-6">Counts toward Chase 5/24</div>
                        </vs-col>
                         <vs-row>
                            <div class="ml-4 mb-1 mt-6 font-semibold">Add breakdown of Annual Fees to calculate Effective Fees</div>
                        </vs-row>
                        <!-- <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
                            <div class="addCardFont font-semibold ml-5 pb-5">Effective Fee Description</div>                                
                                <Editor v-model="cardDetails.effective_fee_description"
                                api-key="oeikwgxzj7ibe8ex4s9ubifc69hoiq52wjylhhoe8c4nr0no" 
                                :init="{
                                selector: 'textarea',
                                content_style: 'body, body a { color: white }',
                                width: '95%',
                                height: 150,
                                menubar: false, 
                                plugins: 'link paste autolink',
                                    toolbar: 'bold italic underline strikethrough | link anchor'}"
                                />
                        </vs-col> -->
                         <div v-show="errors.feeCategory.success" class="ml-5 mb-3">
                            <div id="errFont" class="dangerColor mt-3">
                                <span>{{ errors.feeCategory.msg }}</span>
                            </div>
                        </div>
                        <vs-row :key="index" v-for="(category, index) in cardDetails.fee_categories">
                            <vs-row class="my-2">
                                <vs-col vs-lg="5" class="pr-6 inputContainer">
                                    <div class="addCardFont font-semibold ml-5">Credit Title</div>
                                    <vs-input maxLength="30" placeholder="e.g Uber Credit" class="w-full ml-3" v-model="cardDetails.fee_categories[index].credit_title" :value="index"/>
                                    <vs-col vs-lg="12">
                                        <div class="addCardFont font-semibold ml-3 mt-1 pl-2">Amount</div>
                                        <vs-input maxlength="20" type="number" min="0" class="w-full ml-3 inputContainer" v-model="cardDetails.fee_categories[index].amount" @input="calculateEffectiveFee" @keydown="validateNumeric($event)"/>
                                    </vs-col>
                                </vs-col>
                                <vs-col vs-lg="6" class="pr-6 inputContainer pt-6 tinymce-dynamic-wrapper">
                                     <Editor v-model="category.description"
                                  api-key="oeikwgxzj7ibe8ex4s9ubifc69hoiq52wjylhhoe8c4nr0no" 
                                    :init="{
                                    selector: 'textarea',
                                    content_style: 'body, body a { color: white }',
                                    width: '95%' ,
                                    height: 100,
                                    menubar: false, 
                                    plugins: 'link paste autolink',
                                    default_link_target: '_blank',
                                     toolbar: 'bold italic underline strikethrough | link anchor'}"
                                    />
                                </vs-col>
                                <vs-col vs-lg="1" class="flex pt-3">
                                    <div class="flex flex-wrap-reverse items-center cursor mt-3 pl-3 fix-category-remove-btn" @click="removeCategoryItem(index)">
                                        <MinusSquareIcon color="white"/>
                                        <div class="addCardFont font-semibold ml-3 cursor">Remove</div>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </vs-row>
                        <vs-row>
                            <div class="flex flex-wrap-reverse items-center ml-5 cursor my-6" @click="cardDetails.fee_categories.push({ credit_title: '', amount: 0})">
                                <PlusSquareIcon color="white"/>
                                <div id="whiteText" class="addCardFont font-semibold ml-3 cursor">Add Category</div>
                            </div>
                        </vs-row>
                        <vs-col vs-lg="8" class="px-3 pr-0">
                            <vs-row vs-justify="space-between" class="border-top p-3 pr-0">
                                <div id="whiteText">Effective Fee</div>
                                <div id="whiteText">{{ calculatedFee >= 0 ? '$'+calculatedFee : '-$'+(calculatedFee*-1) }}</div>
                            </vs-row>
                        </vs-col>
                    </vs-row>
                </tab-content>

                  <tab-content title="" class="mb-5 tabCard" :before-change="beforeThirdTabChange">
                    <vs-row>
                        <vs-row>
                            <h3 class="p-5">Point Details</h3>
                        </vs-row>
                         <vs-row v-if="cardDetails.points_categories && cardDetails.points_categories.length > 0">
                            <h6 class="p-3 pl-5 valuation">Valuation</h6>
                            <vs-col id="percentage" vs-lg="2" vs-sm="6" class="inputContainer">
                                <vs-input v-model="valuation" maxlength="40" type="number" min="0" class="w-full pl-2" placeholder="Enter Valuation" @keydown="validateNumeric($event,true)"/>
                            </vs-col>
                            <vs-col vs-lg="3">
                                <vs-button class="ml-3" @click="calculatePercentages" :disabled="valuation <= 0">Calculate</vs-button>
                            </vs-col>
                        </vs-row>
                         <div v-show="errors.pointCategories.success" class="ml-5 mb-3">
                            <div id="errFont" class="dangerColor mt-3">
                                <span>{{ errors.pointCategories.msg }}</span>
                            </div>
                        </div>
                        <vs-row>
                            <vs-col vs-lg="8 p-3" vs-sm="12 p-3">
                                <vs-row :key="index" v-for="(category, index) in cardDetails.points_categories">
                                    <vs-col vs-lg="4" class="mt-5 px-2">
                                        <select 
                                            v-model="cardDetails.points_categories[index].points_category" 
                                            class="w-full posSelect p-3"
                                            >
                                            <option v-for="cat in points_categories_option" :key="cat._id" :value="cat._id">
                                                {{ cat.name }}
                                            </option>
                                    </select>
                                    </vs-col>
                                    <vs-col id="percentage" vs-lg="3" class="inputContainer">
                                        <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                                        <vs-input maxlength="3" type="number" min="0" class="w-full p-5 pl-2" placeholder="Percentage" v-model="cardDetails.points_categories[index].percentage" @keydown="validateNumeric($event,true)"/>
                                    </vs-col>
                                    <vs-col vs-lg="2 verticalCenter" vs-type="flex" vs-justify="center">
                                        <vs-input-number v-model="cardDetails.points_categories[index].multiplier" class="inline-flex m-6" min="0"/>
                                    </vs-col>
                                    <vs-col vs-lg="3" vs-type="flex" vs-justify="flex-start">
                                        <div class="flex flex-wrap-reverse items-center ml-6 cursor mt-1" @click="cardDetails.points_categories.splice(index,1)">
                                            <MinusSquareIcon color="white"/>
                                            <div class="addCardFont font-semibold ml-3 cursor">Remove</div>
                                        </div>
                                    </vs-col>
                                </vs-row>       
                                <vs-row>
                                    <div class="flex flex-wrap-reverse items-center ml-2 mt-3 cursor" @click="addPointCategory">
                                        <PlusSquareIcon color="white"/>
                                        <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                                    </div>
                                </vs-row>                         
                            </vs-col>
                            <vs-col vs-lg="4 p-3" vs-sm="12 p-3">
                                <vs-row>
                                    <div class="addCardFont font-semibold ml-3 cursor">Points Description</div>
                                        <!-- <vs-textarea  
                                        class="m-5 p-3 descSize mt-2 ml-2 pt-0 mb-2" 
                                        v-model="cardDetails.points_description"
                                        maxLength="300"
                                        /> -->
                                         <Editor v-model="cardDetails.points_description"
                                        api-key="oeikwgxzj7ibe8ex4s9ubifc69hoiq52wjylhhoe8c4nr0no" 
                                        :init="{
                                        selector: 'textarea',
                                        content_style: 'body, body a { color: white }',
                                        width: '95%' ,
                                        menubar: false, 
                                        plugins: 'link paste autolink',
                                        toolbar: 'bold italic underline strikethrough | link anchor'}"
                                        />
                                </vs-row>
                            </vs-col>
                        </vs-row>
                    </vs-row>
                </tab-content>
                <tab-content title="" class="mb-5 tabCard">
                    <vs-row>
                        <vs-row>
                            <h3 class="p-5 pb-2" v-if="modifiedList && modifiedList.length > 0">Add Active Rules</h3>
                        </vs-row>  
                        <vs-row>
                            <p class="p-5" id="whiteText" v-if="modifiedList && modifiedList.length > 0">Do you want to add active rules for this card?</p>
                            <p class="p-5" id="whiteText" v-if="modifiedList && modifiedList.length == 0">No active rules available for this Issuer</p>
                        </vs-row> 
                    <vs-row v-if="modifiedList && modifiedList.length > 0"> 
                        <vs-row v-if="errors.rules.success">
                            <p id="errFont" class="p-5 py-3 dangerColor">{{ errors.rules.msg }}</p>
                        </vs-row> 
                        <vs-row id="whiteText">
                            <vs-radio v-model="cardDetails.active_rules_check" vs-name="rule" vs-value="Yes" class="m-5" @change="updateRule('Yes')">Yes</vs-radio>
                            <vs-radio v-model="cardDetails.active_rules_check" vs-name="rule" vs-value="No" class="m-5" @change="updateRule('No')">No</vs-radio>
                        </vs-row>
                        <vs-row :key="index" v-for="(rule, index) in cardDetails.activeRules" v-bind:class="{ 'hidder': cardDetails.active_rules_check == 'No'}">
                             <vs-col vs-lg="6" vs-sm="12" class="px-3 pl-4" id="ruleOptionContainer">
                                 <div class="my-2">Active Rule {{ index+1 }}</div>
                                  <select v-model="cardDetails.activeRules[index].rule" class="w-full posSelect p-3">
                                    <option v-for="option in modifiedList" :key="option._id" :value="option._id">
                                        {{ option.rule }}
                                    </option>
                                  </select>
                             </vs-col>
                             <vs-col vs-lg="3" vs-sm="6">
                                 <div class="my-2 ml-5">Effective Dates</div>
                                 <Datepicker v-model="cardDetails.activeRules[index].effectiveDate" wrapper-class="p-5 mt-0 pt-0" calendar-class="posCalendar" input-class="bgColorInput" placeholder="MM/DD/YYYY" format="MM/dd/yyyy"/>
                             </vs-col>
                              <vs-col vs-lg="3" vs-sm="6">
                                <div class="flex flex-wrap-reverse items-center ml-6 cursor mt-3 pl-6 pt-6" @click="cardDetails.activeRules.splice(index,1)">
                                    <MinusSquareIcon color="white"/>
                                    <div class="addCardFont font-semibold ml-3 cursor">Remove</div>
                                </div>
                            </vs-col>
                        </vs-row>
                        <vs-row v-bind:class="{ 'hidder': cardDetails.active_rules_check == 'No'}">
                            <div class="flex flex-wrap-reverse items-center ml-5 cursor" @click="addNewRule">
                                <PlusSquareIcon color="white"/>
                                <h6 class="ml-2 mt-1 cursor">Add Rule</h6>
                            </div>
                        </vs-row>
                    </vs-row>
                    </vs-row>
                </tab-content>
                
            </form-wizard>
            <ContactModal :display-contact-modal.sync="displayContactModal" :user="currentUserId"/>
        </div>
    </vs-row>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { UploadCloudIcon, PlusSquareIcon, MinusSquareIcon } from 'vue-feather-icons';
import { mixin as clickaway } from 'vue-clickaway';
import Datepicker from 'vuejs-datepicker';

import EventBus from '@/event-bus.js';
import Editor from '@tinymce/tinymce-vue';

import { validateIssuerName, validateUpgradeCard, validateCardName, validateProductChange,
       validateDowngradeCard, validateUploadPhoto, validateAnnualFee, validateAlphaNumeric, validateNumeric, validateRules, validateFeeCategory, validatePoints } from '@/views/admin/validation';
import { genericErrorMessage, toast } from '@/keys/toast-messages';
import ContactModal from '@/components/contact-modal';

export default {
    data() {
        return {
            currentUserId: '',
            displayContactModal: false,
            valuation: '',
            toggleColorList: false,

            calculatedFee: 0,
            cardDetails: {
                issuer: {
                    name: '',
                    _id: ''
                },
                name: '',
                active_rules_check: 'No',
                card_type: 'credit',
                annual_fee: '',
                upgrade_card: '',
                product_change: '',
                downgrade_card: '',
                points_description: '',
                effective_fee_description: '',
                international_transaction: false,
                photo: '',
                fee_categories: [],
                activeRules: [],
                points_categories: [],
                five_twenty_four: true
            },
            points_categories_option: [],

            issuersList: [],

            cardsList: [],
            toggleCardsList: false,

            rulesList: [],
            
            errors: {
                issuerName: {
                    msg: '',
                    success: false
                },
                upgradeCard: {
                    msg: '',
                    success: false
                },
                cardName: {
                    msg: '',
                    success: false
                },
                productChange: {
                    msg: '',
                    success: false
                },
                downgradeCard: {
                    msg: '',
                    success: false
                },
                photo: {
                    msg: '',
                    success: false
                },
                annualFee: {
                    msg: '',
                    success: false
                },
                rules: {
                    msg: '',
                    success: false
                },
                feeCategory: {
                    msg: '',
                    success: false
                },
                pointCategories: {
                    msg: '',
                    success: false
                }
            },
            validateIssuerName,
            validateUpgradeCard,
            validateCardName,
            validateProductChange,
            validateDowngradeCard,
            validateUploadPhoto,
            validateAnnualFee,
            validateAlphaNumeric,
            validateNumeric,
            validateRules,
            validateFeeCategory,
            validatePoints,

            modifiedList: [],
            temp_issuer_name: '',
            genericErrorMessage,
            toast
        }
    },
    methods: {
        showingContactModal(profile){
            this.displayContactModal = false; 
            this.displayContactModal = true;
            this.currentUserId = profile.user;
        },
        calculatePercentages(){
            this.cardDetails.points_categories.forEach((value, index) => {
                if(value.multiplier > 0){
                    this.cardDetails.points_categories[index].percentage = value.multiplier * this.valuation;
                } else {
                    this.cardDetails.points_categories[index].percentage = ''
                }
            });
        },
        async addPointCategory(){
            await this.cardDetails.points_categories.push({ points_category: '', percentage: '', multiplier: 0, type: 'single' });
        },
        async checkIssuerName(value){
            await this.validateIssuerName(value);
            let name = value.trim();
            let objFound = await this.issuersList.find(o => o.name === name);
            if((objFound && objFound.name)){
                this.cardDetails.issuer = objFound;
            }
            else {
                this.cardDetails.issuer = {
                    _id: '0',
                    name: name,
                    color: '#4B4BF9'
                }
                this.modifiedList = [];
                this.cardDetails.activeRules = [];
            }
        },
        setIssuer(issuer){
            this.cardDetails.issuer = issuer;
            this.temp_issuer_name = this.cardDetails.issuer.name;
        },
        calculateRulesWidth(){
            this.modifiedList = [];
            let maxLength = 80;
            for(var i = 0; i < this.rulesList.length ; i++){
                this.modifiedList[i] = {
                        rule: '',
                        _id: ''
                    }
                if(this.rulesList[i].rule.length > maxLength){
                    this.modifiedList[i] = {
                        rule: this.rulesList[i].rule.substr(0, maxLength) + '...', 
                        _id: this.rulesList[i]._id
                    } 
                }
                else {
                    this.modifiedList[i] = {
                        rule: this.rulesList[i].rule, 
                        _id: this.rulesList[i]._id
                    } 
                }
            }
        },
        handleCardFilter(){
            this.toggleCardsList = true;
        },
        closeCardsList(){
            this.toggleCardsList = false;
        },
        
        handleFilter(){
            this.toggleColorList = true;
        },
        closeColorList(){
            if(this.toggleColorList){
                this.toggleColorList = false;
                if(this.cardDetails.issuer.name){
                    this.errors.issuerName = {
                            msg: '',
                            success: false
                    }
                }
                this.getCardsList();
                this.getRules();
            }
        },

         async beforeFirstTabChange(){
            await this.validateIssuerName(this.cardDetails.issuer.name);
            await this.validateCardName(this.cardDetails.name);
            if(!this.errors.photo.success){
                await this.validateUploadPhoto(this.cardDetails.photo);
            }
            let { issuerName, cardName, photo } = this.errors;
            if(issuerName.success || cardName.success || photo.success ){
                return false;
            }
            this.errors.rules = {
                msg: '',
                success: false
            },
            this.getRules();
            return true;
        },
         async beforeSecondTabChange(){
            await this.validateAnnualFee(this.cardDetails.annual_fee);
            await this.validateFeeCategory(this.cardDetails.fee_categories);
            let { annualFee, feeCategory } = this.errors;
            if(annualFee.success || feeCategory.success){
                return false;
            }
            return true;
        },
        async beforeThirdTabChange(){
            await this.validatePoints(this.cardDetails.points_categories,'pointCategories')
             let { pointCategories } = this.errors;
            if(pointCategories.success){
                return false;
            }
            return true
        },
        removeCategoryItem(index){
            this.cardDetails.fee_categories.splice(index,1);
            this.calculateEffectiveFee();
        },
        calculateEffectiveFee(){
            let result = 0;
            for (var i = 0; i < this.cardDetails.fee_categories.length ; i++) {
                result += Number(this.cardDetails.fee_categories[i].amount);
            }
            // if(result >= this.cardDetails.annual_fee){
            //     this.calculatedFee = 0;
            // } else {
                this.calculatedFee = this.cardDetails.annual_fee - result;
            // }
            this.validateAnnualFee(this.cardDetails.annual_fee);
        },
  
        addNewRule(){
            this.cardDetails.activeRules.push({ effectiveDate: '', rule: { _id: '' }});
        },
        showFilePath(){
            this.cardDetails.photo = this.$refs.uploadAddCard.files[0];
            if(this.cardDetails.photo){
                this.validateUploadPhoto(this.cardDetails.photo);
                let format = this.$refs.uploadAddCard.files[0].type.split('/').pop();
                if(this.$refs.uploadAddCard.files[0].size/1048576 > this.$maxFileSize){
                    this.errors.photo = {
                        msg: 'Photo size must be less than '+this.$maxFileSize+' MB',
                        success: true
                    }
                }
                else {
                    this.errors.photo = {
                        msg: '',
                        success: false
                    }
                    if(!this.$photoFormats.includes(format)){
                        this.errors.photo = {
                            msg: 'Please select a valid photo format',
                            success: true
                        }
                    }
                    else {
                        this.errors.photo = {
                            msg: '',
                            success: false
                        }
                    }
                }
            }
            else {
                this.errors.photo = {
                    msg: 'Upload Photo is required',
                    success: true
                }
            }
        },
        updateRule(rule){
            this.cardDetails.active_rules_check = rule;
        },
         getCardsList(){
             if(this.cardDetails.issuer._id != '' && this.cardDetails.issuer._id != '0'){
                    return new Promise(async (resolve) => {
                        await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.GetIssuerCards +
                        "/" + this.cardDetails.issuer._id + "/cards")
                        .then(async res => {
                            if(res.data.success){
                                resolve(
                                    this.cardsList = res.data.data
                                );
                                if(this.cardsList.length == 0){
                                    this.cardDetails.upgrade_card = '',
                                    this.cardDetails.product_change =  '',
                                    this.cardDetails.downgrade_card = ''
                                }
                            } else {
                                this.toast(this.genericErrorMessage());
                            }
                        }).catch(e => {
                            if(e.response.status !== 401){
                                this.toast(this.genericErrorMessage());
                            }
                        });
                    });
               }
            },
        getIssuers(){
            return new Promise(async (resolve) => {
                await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.IssuerColors)
                .then(async res => {
                    if(res.data.success){
                        resolve(
                            this.issuersList = res.data.data.issuers,
                            this.filtererdList = res.data.data.filteredIssuers
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                });
            });
        },
        async approveCard(){
            this.cardDetails.points_categories = await this.cardDetails.points_categories.map(value => {
                value.percentage = Number(value.percentage) > 0 ? Number(value.percentage) : '';
                value.multiplier = Number(value.multiplier);
                return value;
             });

            this.cardDetails.activeRules = await this.cardDetails.activeRules.filter(function(value){
                value.effectiveDate = value.effectiveDate ? value.effectiveDate : new Date();
                return value.rule ? value : null;

            });

            this.validateRules(this.cardDetails.activeRules.length,this.cardDetails.active_rules_check);

            if(!this.errors.rules.success){
                this.cardDetails.fee_categories = await this.cardDetails.fee_categories.map(value => {
                    value = {
                        credit_title: value.credit_title ? value.credit_title : '', 
                        amount: value.amount ? value.amount : 0,
                        description: value.description ? value.description : ''
                    };
                    return value;
                });
                this.cardDetails.issuer.name = this.temp_issuer_name;
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
                var data = new FormData();
                data.append('requestId',this.cardDetails._id);
                data.append('profiles',JSON.stringify(this.cardDetails.profiles));
                data.append('issuer',this.cardDetails.issuer.name ? this.cardDetails.issuer.name : this.cardDetails.issuer._id);
                data.append('name',this.cardDetails.name);
                data.append('card_type',this.cardDetails.card_type);
                data.append('product_change',this.cardDetails.product_change ? this.cardDetails.product_change : '');
                data.append('upgrade_card',this.cardDetails.upgrade_card ? this.cardDetails.upgrade_card : '');
                data.append('downgrade_card',this.cardDetails.downgrade_card ? this.cardDetails.downgrade_card : '');
                data.append('photo',this.cardDetails.photo);
                data.append('annual_fee',Number(this.cardDetails.annual_fee));
                data.append('effective_fee',Number(this.calculatedFee));
                data.append('fee_categories',JSON.stringify(this.cardDetails.fee_categories));
                // data.append('effective_fee_description',this.cardDetails.effective_fee_description);
                data.append('international_transaction',this.cardDetails.international_transaction);
                data.append('five_twenty_four',this.cardDetails.five_twenty_four ? this.cardDetails.five_twenty_four : false);
                data.append('points_categories',JSON.stringify(this.cardDetails.points_categories));

                data.append('points_description',this.cardDetails.points_description ? this.cardDetails.points_description : '');
                data.append('active_rules_check',this.cardDetails.active_rules_check == 'Yes' && this.cardDetails.activeRules.length > 0  ? true : false);
                data.append('activeRules',this.cardDetails.active_rules_check == 'Yes' ? JSON.stringify(this.cardDetails.activeRules) : JSON.stringify([]));

                return new Promise(() => {
                    this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.ApproveCards,data, { 
                        headers: {
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(async res => {
                        this.$vs.loading.close();
                        if(res.data.success){
                            this.$router.push({ name: 'view-cards', params: { approve: true } });
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        this.$vs.loading.close();
                        if(e.response.data.errors && e.response.data.errors.card){
                                this.$refs.wiz.changeTab(3,0); 
                                this.errors.cardName = {
                                    msg: e.response.data.errors.card,
                                    success: true
                                };
                        }
                        else {
                            this.errors.cardName = {
                                msg: '',
                                success: false
                            };
                        }
                         if(e.response.data.errors.points_category){
                            this.$refs.wiz.changeTab(3,2); 
                            this.errors.pointCategories = {
                                    msg: e.response.data.errors.points_category,
                                    success: true
                                }
                            }
                            else {
                            this.errors.pointCategories = {
                                msg: '',
                                success: false
                            }
                             if(e.response.data.errors.duplicatePointCategories){
                                this.$refs.wiz.changeTab(3,2); 
                                this.errors.pointCategories = {
                                        msg: e.response.data.errors.duplicatePointCategories,
                                        success: true
                                    }
                                }
                                else {
                                this.errors.pointCategories = {
                                    msg: '',
                                    success: false
                                }
                                if(e.response.data.errors.percentage){
                                    this.$refs.wiz.changeTab(3,2); 
                                    this.errors.pointCategories = {
                                            msg: e.response.data.errors.percentage,
                                            success: true
                                        }
                                    }
                                else {
                                    this.errors.pointCategories = {
                                        msg: '',
                                        success: false
                                    }
                                    if(e.response.data.errors.multiplier){
                                        this.$refs.wiz.changeTab(3,2); 
                                        this.errors.pointCategories = {
                                                msg: e.response.data.errors.multiplier,
                                                success: true
                                            }
                                        }
                                        else {
                                            this.errors.pointCategories = {
                                                msg: '',
                                                success: false
                                        }
                                    }
                                }
                            }
                        }
                        if(e.response.data.errors.duplicateRules){
                            this.errors.rules = {
                                msg: e.response.data.errors.duplicateRules,
                                success: true
                            }
                        }
                        else {
                            this.errors.rules = {
                                msg: '',
                                success: false
                            }
                        }
                        if(e.response.data.errors.duplicateCategories){
                            this.$refs.wiz.changeTab(3,1); 
                            this.errors.feeCategory = {
                                msg: e.response.data.errors.duplicateCategories,
                                success: true
                            }
                        }
                        else {
                            this.errors.feeCategory = {
                                msg: '',
                                success: false
                            }
                        }
                        if(!e.response.data.errors && !e.response.data.errors.card && !e.response.data.errors.points_category && !e.response.data.errors.duplicateRules && !e.response.data.errors.duplicateCategories){
                            if(e.response.status !== 401){
                                this.toast(this.genericErrorMessage());
                            }
                        }
                    });
                });
            }
        },
         getRules(){
             if(this.cardDetails.issuer._id != '' && this.cardDetails.issuer._id != '0'){
                return new Promise(async (resolve) => {
                    await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.Rules, { 
                        params: {
                            issuerId: this.cardDetails.issuer._id
                        }
                    }).then(async res => {
                        if(res.data.success){
                            resolve(
                                this.rulesList = res.data.data,
                                this.calculateRulesWidth()
                            );
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        if(e.response.status !== 401){
                            this.toast(this.genericErrorMessage());
                        }
                    });
                });   
             }
        },
        getCategories(){
           this.$vs.loading({
                background: 'rgba(1,2,3,.2)'
            });
           return new Promise((resolve) => {
                this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.PointCategories + `?type=walletflo`)
                .then(async res => {
                    this.$vs.loading.close();
                    if(res.data.success){
                        resolve(
                            this.points_categories_option = res.data.data
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    this.$vs.loading.close();
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                    // console.log("Error in getCategories: ",e);
                });
            });
       },
    },
    created() {
        this.getIssuers();
        this.getCategories();
        EventBus.$emit('resetToggleGroup',true);
    },
    mounted() {
        this.cardDetails.issuer.name = this.$route.params.issuerName ? this.$route.params.issuerName : this.$route.params.issuerId.name;
        this.cardDetails.issuer._id = this.$route.params.issuerId && this.$route.params.issuerId._id ? this.$route.params.issuerId._id : '';
        this.cardDetails.name = this.$route.params.cardName;
        this.cardDetails.profiles = this.$route.params.profiles;
        this.temp_issuer_name = this.cardDetails.issuer.name
        this.cardDetails._id = this.$route.params.id;
        this.getCardsList();
    },
    components: {
        FormWizard,
        TabContent,
        UploadCloudIcon,
        PlusSquareIcon,
        MinusSquareIcon,
        Datepicker,
        Editor,
        ContactModal
    },
    mixins: [ clickaway ]
}
</script>

<style>
    @import '../../../../assets/css/tinymce.css';
    @import './style.css';
    @import '../../../../assets/css/add-edit-approve-card.css';
</style>

















/*



*/











